import { EditInspectionForm } from "src/components/Forms/EditInspectionForm";
import { useParams } from "react-router-dom";
export function EditDeviation() {
  const { deviationId } = useParams();
  return <EditInspectionForm id={deviationId || ""} />;
}
